import type { PlaceModel } from 'owa-location-service';
import { getBingUrl } from 'owa-location-persona';
import loc from 'owa-localize';
import { bingUrlError } from '../location.locstring.json';

export default function getDirections(place: PlaceModel | undefined): string {
    if (place != undefined) {
        const url = getBingUrl(
            place.Coordinates?.Latitude,
            place.Coordinates?.Longitude,
            place?.PlaceDetails?.FormattedAddress ?? '',
            place.Name
        );
        return url ?? loc(bingUrlError);
    }
    return loc(bingUrlError);
}
